import axiosClient from '../util/request';
import dayjs from 'dayjs';

const cookieRepo = {
  accept: async () => {
    const bodyFormData = new FormData();
    bodyFormData.append('dateAccept', dayjs().format());

    return axiosClient.post('/v1/audit/accept-cookies', bodyFormData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
};

export default cookieRepo;